module.exports = __webpack_public_path__ + "files/d97d74b8ef8cdc2866c954449d573b1f.png";